// Reason for separating is that ConfirmationDialog.vue value state is shared globally
import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let AffiliateSettingsConfirm = class AffiliateSettingsConfirm extends Mixins(ViewportSizeMixin) {
    get commissionTypeText() {
        if (this.commissionType === 'percentage') {
            return 'Percentage of Sale';
        }
        return 'Absolute';
    }
    get commissionAmountText() {
        if (this.commissionType === 'percentage') {
            return `${this.commissionAmount}%`;
        }
        return `₱${this.commissionAmount}`;
    }
    onConfirm() {
        this.$emit('confirm');
    }
    onCancel() {
        this.$emit('cancel');
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], AffiliateSettingsConfirm.prototype, "toggle", void 0);
__decorate([
    Prop({ type: String, default: false })
], AffiliateSettingsConfirm.prototype, "commissionType", void 0);
__decorate([
    Prop({ type: Number, default: false })
], AffiliateSettingsConfirm.prototype, "commissionAmount", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], AffiliateSettingsConfirm.prototype, "requestOnProcess", void 0);
AffiliateSettingsConfirm = __decorate([
    Component({
        components: {
            ActionButton,
        },
    })
], AffiliateSettingsConfirm);
export default AffiliateSettingsConfirm;
